import mixinUILifeCycle from './component/UILifeCycle'
export default class PSprite extends PIXI.Sprite {
    constructor() {
        super();

        this.initLifeCycle();
    }
}
mixinUILifeCycle(PSprite.prototype);



// WEBPACK FOOTER //
// ./src/common/scripts/pixi/PSprite.js